import {Entity} from '../../../../models/entity';
import {deserializeAs, inheritSerialization} from 'cerialize';
import {Logement} from '../../../../models/logement';
import {HabitudeChauffageEnum} from '../enums/HabitudeChauffageEnum';
import {AmpouleEnum} from '../enums/AmpouleEnum';
import {HabitudeCuissonEnum} from '../enums/HabitudeCuissonEnum';
import {UtilisationCuissonEnum} from '../enums/UtilisationCuissonEnum';
import {HabitudeECSEnum} from '../enums/HabitudeECSEnum';
import {NiveauSaisieEnum} from '../enums/NiveauSaisieEnum';
import {ClassEnergetiqueEnum} from '../enums/ClassEnergetiqueEnum';

@inheritSerialization(Entity)
export class UsageOccupant extends Entity {

  logement: Logement;

  @deserializeAs('nb_occupants')
  nbOccupants: number;

  @deserializeAs(HabitudeChauffageEnum, 'habitude_chauffage')
  habitudeChauffage: HabitudeChauffageEnum;

  @deserializeAs('lampadaires_nb')
  lampadairesNb: number;

  @deserializeAs(AmpouleEnum, 'lampadaires_ampoule')
  lampadairesAmpoule: AmpouleEnum;

  @deserializeAs('lampes_nb')
  lampesNb: number;

  @deserializeAs(AmpouleEnum, 'lampes_ampoule')
  lampesAmpoule: AmpouleEnum;

  @deserializeAs('plafonniers_nb')
  plafonniersNb: number;

  @deserializeAs(AmpouleEnum, 'plafonniers_ampoule')
  plafonniersAmpoule: AmpouleEnum;

  @deserializeAs('appliques_nb')
  appliquesNb: number;

  @deserializeAs(AmpouleEnum, 'appliques_ampoule')
  appliquesAmpoule: AmpouleEnum;

  @deserializeAs('spots_nb')
  spotsNb: number;

  @deserializeAs(AmpouleEnum, 'spots_ampoule')
  spotsAmpoule: AmpouleEnum;

  @deserializeAs('tubes_nb')
  tubesNb = 0;

  @deserializeAs('prix_electricite')
  prixElectricite: number;

  @deserializeAs('prix_gaz')
  prixGaz: number;

  @deserializeAs('coef_conversion_gaz')
  coefConversionGaz: number;

  @deserializeAs('coef_conversion_fioul')
  coefConversionFioul: number;

  @deserializeAs('cuisson_plaque_gaz_fixe')
  cuissonPlaqueGazFixe: boolean;

  @deserializeAs('cuisson_plaque_elec_fixe')
  cuissonPlaqueElecFixe: boolean;

  @deserializeAs('cuisson_plaque_elec_port')
  cuissonPlaqueElecPort: boolean;

  @deserializeAs('cuisson_four_microondes')
  cuissonFourMicroondes: boolean;

  @deserializeAs('cuisson_four_elec')
  cuissonFourElec: boolean;

  @deserializeAs('cuisson_four_gaz')
  cuissonFourGaz: boolean;

  @deserializeAs(HabitudeCuissonEnum, 'habitudes_cuisson')
  habitudesCuisson: HabitudeCuissonEnum;

  @deserializeAs(UtilisationCuissonEnum, 'utilisation_cuisson')
  utilisationCuisson: UtilisationCuissonEnum;

  @deserializeAs('combine_nb')
  combineNb: number;

  @deserializeAs('refrigerateur_nb')
  refrigerateurNb: number;

  @deserializeAs('congelateur_nb')
  congelateurNb: number;

  @deserializeAs('tv_lcd_nb')
  tvLcdNb: number;

  @deserializeAs('tv_plasma_nb')
  tvPlasmaNb: number;

  @deserializeAs('ordinateur_nb')
  ordinateurNb: number;

  @deserializeAs('modem_nb')
  modemNb = 1;

  @deserializeAs('imprimante_nb')
  imprimanteNb: number;

  @deserializeAs('aspirateur_nb')
  aspirateurNb = 1;

  @deserializeAs('fer_nb')
  ferNb = 1;

  @deserializeAs('aquarium_nb')
  aquariumNb = 0;

  @deserializeAs('baignoire_nb')
  baignoireNb: number;

  @deserializeAs('douche_nb')
  doucheNb: number;

  @deserializeAs('lave_vaisselle_nb')
  laveVaisselleNb: number;

  @deserializeAs('lave_linge_nb')
  laveLingeNb: number;

  @deserializeAs('seche_linge_nb')
  secheLingeNb: number;

  @deserializeAs(HabitudeECSEnum, 'habitudes_ecs')
  habitudesEcs: HabitudeECSEnum;

  @deserializeAs('lave_vaisselle_ecs')
  laveVaisselleEcs = false;

  @deserializeAs('lave_linge_ecs')
  laveLingeEcs = false;

  @deserializeAs(ClassEnergetiqueEnum, 'classe_ener_combi')
  classeEnerCombi: ClassEnergetiqueEnum;

  @deserializeAs(ClassEnergetiqueEnum, 'classe_ener_refrigerateur')
  classeEnerRefrigerateur: ClassEnergetiqueEnum;

  @deserializeAs(ClassEnergetiqueEnum, 'classe_ener_congelateur')
  classeEnerCongelateur: ClassEnergetiqueEnum;

  @deserializeAs(ClassEnergetiqueEnum, 'classe_ener_lave_linge')
  classeEnerLaveLinge: ClassEnergetiqueEnum;

  @deserializeAs(ClassEnergetiqueEnum, 'classe_ener_seche_linge')
  classeEnerSecheLinge: ClassEnergetiqueEnum;

  @deserializeAs(ClassEnergetiqueEnum, 'classe_ener_lave_vaisselle')
  classeEnerLaveVaisselle: ClassEnergetiqueEnum;

}
